<kiwi-header class="cell shrink" (menuToggled)="toggleMenu($event)"></kiwi-header>

<div class="cell auto grid-x">
    <kiwi-menu [class._sideMenuClose]="!menuVisible" class="cell shrink">
    </kiwi-menu>
    <router-outlet (activate)="onRouterActivate($event)">
    </router-outlet>
</div>
